import { useNavigate, useParams } from "react-router-dom";
import { 
  Box, 
  Button, 
  Flex, 
  Text, 
  SimpleGrid,
  GridItem
} from "@chakra-ui/react";
import { Header } from "../../components/Header";
import { Limites } from "../Pdv/LImites";
import { Loading } from "../../components/Loading";
import { formatBRL } from "../../utils/currency";
import { useFaturaDetalhes } from "../../hooks/fatura/useFaturaDetalhes";
import { HiArrowUturnLeft } from "react-icons/hi2";

export function PagamentoFaturaFinalizado() {
  const navigate = useNavigate()
  const { id } = useParams() as { id: string };
  
  const { data: fatura, isLoading } = useFaturaDetalhes({ id });

  if (isLoading) return <Loading />;

  if (typeof fatura === "undefined") {
    return <Loading />;
  }

  const statusConfig = {
    'Paga': {
      texto: "PAGA COM SUCESSO",
      cor: "green.400"
    },
    'Vencida': {
      texto: "ESTÁ VENCIDA",
      cor: "red.500"
    },
    'Aberta': {
      texto: "ESTÁ EM ABERTO",
      cor: "blue.500"
    },
    'Fechada': {
      texto: "ESTÁ FECHADA",
      cor: "gray.500"
    }
  };

  const configAtual = statusConfig[fatura.status_label] || statusConfig['Aberta'];

  let formaPagamento = "Não Identificada";
  if (fatura.pix_id) {
    formaPagamento = "PIX";
  } else if (fatura.boleto_id) {
    formaPagamento = "Boleto";
  }

  return (
    <Box
      display={"flex"}
      flexDir={"column"}
      justifyContent={"center"}
      width={"full"}
      alignItems={"center"}
    >
      <Flex
        maxWidth={"140rem"}
        width={"100%"}
        flexDir={"column"}
        justifyContent={"center"}
      >
        <Header />
        <Box
          px={"1rem"}
          bg={"white"}
          w={"full"}
          display={"flex"}
          flexDir={"column"}
          gap={"8"}
          pb={8}
        >
          <Limites />

          <Box bg={"#f4f4f4"} p={"4"} display={"flex"} flexDir={"column"}>
            <Text fontSize={"lg"} fontWeight={"900"}>
              CONFIRMAÇÃO
            </Text>
            <Text textAlign={"center"} fontSize={"7xl"} color={configAtual.cor}>
              FATURA #{id} {configAtual.texto}
            </Text>
            <Text textAlign={"center"} fontSize={"7xl"} color={configAtual.cor}>
              Valor Total {formatBRL(Number(fatura.valor_total))}
            </Text>
          </Box>

          <Box bg={"#f4f4f4"} p={"4"} display={"flex"} flexDir={"column"} gap={2}>
            <Text fontSize={"lg"} fontWeight={"bold"}>
              Detalhes da Fatura
            </Text>
            
            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4} mt={2}>
              <GridItem>
                <Text fontSize="sm" color="gray.600">Código da Fatura</Text>
                <Text fontWeight="bold">{fatura.codigo}</Text>
              </GridItem>
              <GridItem>
                <Text fontSize="sm" color="gray.600">Forma de Pagamento</Text>
                <Text fontWeight="bold">{formaPagamento}</Text>
              </GridItem>
              <GridItem>
                <Text fontSize="sm" color="gray.600">Data de Fechamento</Text>
                <Text fontWeight="bold">{fatura.data_fechamento}</Text>
              </GridItem>
              <GridItem>
                <Text fontSize="sm" color="gray.600">Data de Vencimento</Text>
                <Text fontWeight="bold">{fatura.data_vencimento}</Text>
              </GridItem>
            </SimpleGrid>
          </Box>

          <Flex justifyContent={'center'}>
            <Button onClick={() => navigate('/')} width={'320px'} height={'50px'} fontSize={'2xl'} fontWeight={'bold'} leftIcon={<HiArrowUturnLeft size={'40px'} />} bgColor={'yellow.400'}>Voltar ao Inicio</Button>
          </Flex>
        </Box>
      </Flex>
    </Box>
  );
}